import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';

export interface BillingUsageSlice {
    category: string;          // WHATSAPP | EMAIL | SMS | CAMPAIGN | AI | OTHER
    label?: string;
    amount: number;
}

export interface BillingSummary {
    balance?: number;
    updatedAt?: string;
    lastTopUp?: number;
    aiOverdraftLimit?: number;  // 10% of last top-up
    aiHeadroom?: number;        // balance + aiOverdraftLimit
    status?: 'HEALTHY' | 'LOW' | 'OVERDRAWN' | 'UNLIMITED';
    spend30dTotal?: number;
    spend30d?: BillingUsageSlice[];
}

export interface BillingLedgerEntry {
    id: string;
    type: 'CREDIT' | 'DEBIT';
    amount: number;
    reason?: string;
    refType?: string;
    balanceAfter?: number;
    createdByName?: string;
    createdAt?: string;
}

/** Company-side billing — wallet snapshot + the usage ledger. */
@Injectable({ providedIn: 'root' })
export class BillingService {

    constructor(private api: ApiService) {}

    getSummary(): Observable<BillingSummary> {
        return this.api.get<any>('/api/credits/summary').pipe(map(r => (r?.data ?? r ?? {}) as BillingSummary));
    }

    getLedger(page = 0, size = 50): Observable<{ content: BillingLedgerEntry[]; totalElements: number }> {
        return this.api.get<any>('/api/credits/ledger', { page, size })
            .pipe(map(r => (r?.data ?? r ?? { content: [], totalElements: 0 }) as { content: BillingLedgerEntry[]; totalElements: number }));
    }
}
